import types from './management.types';

const INITIAL_STATE = {
  customerList: [],
  supplierList: [],
  userList: [],
};

const managementReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.MANAGEMENT_SET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: payload,
      };
    case types.MANAGEMENT_SET_SUPPLIER_LIST:
      return {
        ...state,
        supplierList: payload,
      };
    case types.MANAGEMENT_SET_USER_LIST:
      return {
        ...state,
        userList: payload,
      };
    default:
      return state;
  }
};

export default managementReducer;
